// 自定义配置，参考 ./default/setting.config.js，需要自定义的属性在这里配置即可
module.exports = {
  theme: {
    color: '#8A1106', //'#8A1106',
    mode: 'lightmenu',
    success: '#52c41a',
    warning: '#faad14',
    error: '#f5222f'
  },
  fixedHeader: true,
  animate: {
    disabled: true,
    name: 'lightSpeed',
    direction: 'left'
  },
  hideSetting: true,
}
      